<template lang="pug">
    section#blockLocalizacao
        SvgIcon(data="@svgs/detalhe_2.svg", original).detalhe
        .header
            Titulo(:content="tituloBlock")
            .content
                Imagem(:content="images[0]")
                .text
                    h1 {{ textBlock.titulo }}
                    h2 {{ textBlock.subtitulo }}
        .body
            Mapa(:content="enderecoBlock")
            .contact
                .endereco
                    FontAwesomeIcon(:icon="icons.faMapMarkerAlt")
                    p {{ enderecoBlock.rua }}, {{ enderecoBlock.numero }}
                    p {{ enderecoBlock.bairro }}, CEP {{ enderecoBlock.cep }}
                    p {{ enderecoBlock.cidade }} {{ enderecoBlock.estado | uppercase }}
                .telefones(v-if="$configuracoes.telefone || $configuracoes.whatsapp")
                    FontAwesomeIcon(:icon="icons.faPhoneAlt")
                    a(:href="$configuracoes.telefoneLink", v-if="$configuracoes.telefone") {{ $configuracoes.telefone }}
                    a(:href="$configuracoes.whatsappLink", v-if="$configuracoes.whatsapp") {{ $configuracoes.whatsapp }}
                .email(v-if="$configuracoes.email_destinatario")
                    FontAwesomeIcon(:icon="icons.faEnvelope")
                    a(:href="$configuracoes.emailLink") {{ $configuracoes.email_destinatario }}
                ul.redes
                    li.rede(v-if="$configuracoes.instagram")
                        a(:href="$configuracoes.instagram", target="_blank")
                            FontAwesomeIcon(:icon="icons.faInstagram")
                    li.rede(v-if="$configuracoes.facebook")
                        a(:href="$configuracoes.facebook", target="_blank")
                            FontAwesomeIcon(:icon="icons.faFacebook")
            Imagem(:content="images[1]")
        .footer
            small {{ textBlock.rodape }}
</template>

<script>
import { faMapMarkerAlt, faEnvelope, faPhoneAlt } from '@fortawesome/free-solid-svg-icons'
import { faFacebookSquare as faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons'
import { components } from '@/mixins/components'

export default {
    name: "component-block-localizacao",
    components,
    props: {
        content: {
            type: Array,
            required: true
        },
    },
    data() {
        return {
            icons: {
                faMapMarkerAlt,
                faEnvelope,
                faPhoneAlt,
                faFacebook,
                faInstagram,
            },
        }
    },
    computed: {
        tituloBlock() {
            return this.content.find(block => block.type == 'titulo_item')
        },
        textBlock() {
            return this.content.find(block => block.type == 'localizacao_textos_item')
        },
        enderecoBlock() {
            return this.content.find(block => block.type == 'localizacao_item')
        },
        images() {
            const localizacao_images_item = this.content.find(block => block.type == 'localizacao_images_item') || []
            return localizacao_images_item != undefined ? localizacao_images_item.images : []
        },
    },
    filters: {
        uppercase(value = '') {
            if (value)
                return value.toUpperCase()
            return ''
        },
    },
}
</script>

<style lang="stylus" scoped src="./BlockLocalizacao.styl"></style>